/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit GenerateAction/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromHelpers from './helpers.js'
import React from 'react'
import TysiaButtonWithText from 'DesignSystem/TysiaButtonWithText/index'



/** @type {import('Simple/types.js').View} */
export default function GenerateAction({
  children,
  viewPath = "/App/Account/Content/Financial/Content/Statements/New/GenerateAction",
  disabled
  
}) {
let reportLastExecutionCreatedAtValueData = fromData.useDataValue({ viewPath,
context: 'report',
path: 'last_execution.created_at',
})
let dtSpaceS = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.s'
        })
let onClick = fromHelpers.useOnClick({
  children,
  viewPath,
  disabled
  
})
  return (<React.Fragment
>
<TysiaButtonWithText
  viewPath={`${viewPath}/TysiaButtonWithText`}
 alignSelf="flex-end"
 marginTop={dtSpaceS}
 type={reportLastExecutionCreatedAtValueData ? "secondary" : "primary"}
 size="normal"
 onClick={onClick}
 disabled={disabled}
 text="Generate statements"
 data="report.last_execution.created_at"
/>
{children}
</React.Fragment>)
}